import { parentUrlParam } from '@/app.config'

export const getRawParentUrl = () => {
  return window.location !== window.parent.location
    ? parentUrlParam
    : document.location.href
}

export const getParentDomain = () => {
  const parentUrl = getRawParentUrl()
  return parentUrl
    .split('/')
    .slice(0, 3)
    .join('/')
}

export const isProbablyCRM = () => {
  const parentDomain = getParentDomain()
  return /crmportal|crmdemo|serviceportal|mietme\.|meine\.d/.test(parentDomain)
}
